import {TimeHorizonId} from '@predict/UtilsLib/dateTime'
import {NumberRange, TargetRange} from '@predict/UtilsLib/general'

export interface FreeLimeSettings {
  axisRange: NumberRange
  targetRange: TargetRange
  defaultTimeDurationFreeLime: TimeHorizonId
}
